<template lang="html">
  <div class="user-reviews__container">
    <div class="user-reviews__content">
      <div class="user-reviews__heading">
        <Heading color="orange" size="h6">
          {{ $t('pages.reviews.user_reviews.subtitle') }}
        </Heading>
        <Heading size="h2">
          {{ $t('pages.reviews.user_reviews.title') }}
        </Heading>
      </div>
      <ClientOnly>
        <masonry
          :cols="{default: 3, 960: 2, 762: 1}"
          :gutter="32"
        >
          <CardReview
            v-for="review in loadedReviews"
            :key="review.id"
            class="user-reviews__card"
            :title="review.title"
            :body="review.body"
            :user="review.user"
            :source="review.source"
          />
        </masonry>
        <div class="user-reviews__end-list">
          <div ref="loadingTrigger" class="user-reviews__list-trigger" />
        </div>
      </ClientOnly>
    </div>
  </div>
</template>

<script>
import CardReview from './CardReview.vue'
import reviewsEn from '@/lib/reviews/en'
import reviewsEs from '@/lib/reviews/es'
import reviewsIt from '@/lib/reviews/it'
import Heading from '@/components/common/Heading/Heading'

export default {
  components: {
    CardReview,
    Heading
  },

  data () {
    return {
      numberReviewsLoaded: 12,
      incrementLoadReviews: 6,
      shuffledList: []
    }
  },

  computed: {
    locatedReviews () {
      const locale = this.$i18n.locale
      switch (locale) {
        case 'es':
          return reviewsEs
        case 'it':
          return reviewsIt
        default:
          return reviewsEn
      }
    },

    loadedReviews () {
      return this.shuffledList.slice(0, this.numberReviewsLoaded)
    }
  },

  mounted () {
    this.shuffledList = this.shuffleList(this.locatedReviews)
    this.$nextTick(() => {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 1.0
      }

      const observer = new IntersectionObserver(this.handleObserver, options)
      const loadingTriggerRef = this.$refs.loadingTrigger
      if (loadingTriggerRef) {
        observer.observe(this.$refs.loadingTrigger)
      }
    })
  },

  methods: {
    handleObserver () {
      this.numberReviewsLoaded = Math.min(this.numberReviewsLoaded + this.incrementLoadReviews, this.shuffledList.length)
    },

    shuffleList (list) {
      for (let i = list.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = list[i]
        list[i] = list[j]
        list[j] = temp
      }
      return list
    }
  }
}
</script>

<style lang="scss" scoped>
.user-reviews {
  &__container {
    width: 100%;
    padding: $gap * 5 $gap;
  }

  &__content {
    margin: 0 auto;
    width: 100%;
    max-width: 1120px;
    display: flex;
    flex-direction: column;
    gap: $gap * 2;
  }

  &__heading {
    display: flex;
    flex-direction: column;
    gap: $gap * 0.5;
  }

  &__card {
    break-inside: avoid;
    margin-bottom: $gap * 2;
    opacity: 0;
    animation: slideInUp 0.5s ease-out forwards;

    @keyframes slideInUp {
      from {
        opacity: 0;
        transform: translateY(120px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  &__end-list {
    position: relative;
  }

  &__list-trigger {
    position: absolute;
    bottom: 30 * $gap;
  }
}
</style>
